import { render } from "./Rate.vue?vue&type=template&id=2d17fcf0"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__